import React from 'react';

const PartnersSection = () => {
  return (
    <section className="section-white partners-paddings section-top-border section-bottom-border">
      <div className="container">
        <div className="row">
          <div className="col-md-12 text-center">
            <h2 className="section-title">Our Partners</h2>
          </div>
          <div className="col-md-12 text-center">
            <ul className="partners-mentions">
              <li><a href="https://itsacheckmate.com" target="_blank" rel="noopener noreferrer"><img src="/assets/images/partners-logo/itsacheckmate-logo.webp" alt="Itsacheckmate" width="200" /></a></li>
              <li><a href="https://smartscreenllc.com" target="_blank" rel="noopener noreferrer"><img src="/assets/images/partners-logo/smartscreen-logo.webp" alt="Smartscreen" /></a></li>
              <li><a href="https://borzodelivery.com/in" target="_blank" rel="noopener noreferrer"><img src="/assets/images/partners-logo/borzo-logo.webp" alt="Borzo" /></a></li>
              <li><a href="https://www.delhivery.com" target="_blank" rel="noopener noreferrer"><img src="/assets/images/partners-logo/delivery-logo.webp" alt="Delivery" /></a></li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PartnersSection;
